import { useState, useEffect } from 'react';

export default function useAdditionalOptions(initialData = {}) {
  const [expanded, setExpanded] = useState(false);

  const [toggles, setToggles] = useState(() => ({
    importantNotes: Boolean(initialData.toggles?.importantNotes),
    externalLinks: Boolean(initialData.toggles?.externalLinks),
    requestDeliveryDetails: Boolean(initialData.toggles?.requestDeliveryDetails),
  }));

  const [extLinks, setExtLinks] = useState(() => initialData.extLinks || []);

  useEffect(() => {
    if (initialData.toggles) {
      setToggles((prev) => ({
        importantNotes: prev.importantNotes || Boolean(initialData.toggles.importantNotes),
        externalLinks: prev.externalLinks || Boolean(initialData.toggles.externalLinks),
        requestDeliveryDetails:
          prev.requestDeliveryDetails || Boolean(initialData.toggles.requestDeliveryDetails),
      }));
    }
    if (Array.isArray(initialData.extLinks) && initialData.extLinks.length > 0) {
      setExtLinks((prev) => (prev.length === 0 ? initialData.extLinks : prev));
    }
  }, [
    initialData.toggles?.importantNotes,
    initialData.toggles?.externalLinks,
    initialData.toggles?.requestDeliveryDetails,
  ]);

  const handleToggle = (key, next) => {
    setToggles((prev) => ({ ...prev, [key]: next }));

    if (key === 'externalLinks' && next && extLinks.length === 0) {
      setExtLinks([{ id: Date.now(), name: '', url: '' }]);
    }
  };

  const addExternalLink = () => {
    setExtLinks((prev) => [...prev, { id: Date.now(), name: '', url: '' }]);
  };

  const removeExternalLink = (id) => {
    setExtLinks((prev) => prev.filter((item) => item.id !== id));
  };

  const updateExternalLink = (id, field, value) => {
    setExtLinks((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [field]: value } : item)));
  };

  return {
    expanded,
    setExpanded,
    toggles,
    handleToggle,
    extLinks,
    addExternalLink,
    removeExternalLink,
    updateExternalLink,
  };
}
